var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Download as csv","placement":"bottom-end"}},[(!_vm.hideIcon)?_c('div',{attrs:{"id":"csvSpinnerTarget"}},[_c('font-awesome-icon',{staticClass:"cursor-pointer",attrs:{"icon":"file-csv","size":"2x"},on:{"click":_vm.csvExport}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }